import { Component, OnDestroy } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Evento, EventoAccreditamentoSummary } from '../../../../shared/interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modifica-accredito-backoffice',
  templateUrl: './modifica-accredito-backoffice.component.html',
  styleUrl: './modifica-accredito-backoffice.component.css',
})
export class ModificaAccreditoBackofficeComponent implements OnDestroy {

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute) {}

  evento?: Evento;
  summary?: EventoAccreditamentoSummary;
  loading: boolean = false;

  private sub = new Subscription();

  ngOnInit(): void {
    this.sub.add(this.route.params.subscribe((params) => {
      this.loading = true;
      const id = params['id'];
      this.apiService.getEvento(id).subscribe({
        next: (data) => this.evento = data,
        error: () => this.router.navigate(['/backoffice/area-compagnie']),
        complete: () => this.reloadSummary(id, true),
      });
    }));

    this.sub.add(this.apiService.documentoStatoChanged.subscribe((idEvento) => {
      if (this.evento && Number(idEvento) === Number(this.evento.id)) {
        this.reloadSummary(this.evento.id, false);
      }
    }));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private reloadSummary(id: number, endLoading: boolean) {
    this.apiService.getEventoAccreditamentoSummary(id).subscribe({
      next: (s) => this.summary = s,
      error: () => this.summary = undefined,
      complete: () => { if (endLoading) this.loading = false; },
    });
  }

  statusLabel(level: string): string {
    switch (level) {
      case 'ok': return 'ok';
      case 'wait': return 'da accettare';
      case 'warn': return 'incompleti';
      case 'crit': return 'mancanti';
      case 'na': return 'n/a';
      default: return level;
    }
  }
}
